import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import navigateToURL from 'lib/navigateToURL';
import {FONT_PROXIMA_13, FONT_PROXIMA_17} from 'styles/FontConstants';
import {GRAY_DARKER, GRAY_LIGHT, GRAY_LIGHTER, NEAR_BLACK} from 'ui-library/Colors';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import MonomerConfigurationPageContainer from './MonomerConfigurationPageContainer';

interface MonomerCreationMethodButtonProps {
  icon: BenchlingIconName;
  text: string;
  url: string;
}

function MonomerCreationMethodButton({icon, text, url}: MonomerCreationMethodButtonProps): JSX.Element {
  return (
    <div
      className={css(styles.methodButton)}
      onClick={() => {
        navigateToURL(url);
      }}
    >
      <div className={css(styles.iconWrapper)}>
        <BenchlingIcon
          className={css(styles.icon)}
          icon={icon}
          dataTestAttrs={{
            component: 'MonomerCreationMethodPicker',
            element: 'creationMethodButton',
          }}
        />
      </div>
      <div className={css(styles.methodText)}>{text}</div>
    </div>
  );
}

export default function MonomerCreationMethodPicker(): JSX.Element {
  return (
    <MonomerConfigurationPageContainer>
      <span className={css(styles.header)}>Select method for adding monomer(s)</span>
      <MonomerCreationMethodButton
        icon="search"
        text="Search HELM library"
        url="/monomers/create/helm-library"
      />
      <MonomerCreationMethodButton icon="upload" text="Upload CSV" url="/monomers/create/bulk-csv" />
      <MonomerCreationMethodButton icon="compose" text="Create new monomer" url="/monomers/create/manual" />
    </MonomerConfigurationPageContainer>
  );
}

const styles = StyleSheet.create({
  header: {...FONT_PROXIMA_17, color: NEAR_BLACK, marginTop: 20, marginBottom: 4},
  methodButton: {
    display: 'flex',
    alignItems: 'center',
    width: 280,
    marginTop: 12,
    borderRadius: 4,
    padding: 6,
    cursor: 'pointer',
    border: `1px solid ${GRAY_LIGHT}`,
    background: 'white',
    ':hover': {
      background: GRAY_LIGHTER,
    },
  },
  iconWrapper: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 26,
    height: 26,
    borderRadius: 4,
    background: GRAY_LIGHT,
  },
  icon: {
    fill: GRAY_DARKER,
  },
  methodText: {
    ...FONT_PROXIMA_13,
    marginLeft: 8,
  },
});
